import React, { Component } from 'react'
import { connect } from 'react-redux'
import { TokenActions, SnackbarActions, CountryActions } from 'actionsets'
import StyleSheet from 'styles'
import {CenteredCard, CountrySelect} from 'components'
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography'
import qs from 'qs'
import FormComponentsMixin from 'containers/shared/FormComponentsMixin'
import {eventKeyMatches, KEYS} from 'utils'

export class AcceptInvitation extends FormComponentsMixin(Component){

  constructor(props){
    super(props)
    this.state = {
      name: this.name,
      countryId: this.countryId
    }
    CountryActions.bindActions(this, 'country')
    TokenActions.bindActions(this)
    SnackbarActions.bindActions(this, 'snackbar')
  }

  componentDidMount = () => {
    this.actions.country.index()
  }

  setPasswordConfirmation = ({target: { value: passwordConfirmation}}) => {
    this.setState({passwordConfirmation})
  }

  setName = ({target: { value: name}}) => {
    this.setState({name})
  }

  setPassword = ({target: { value: password}}) => {
    this.setState({password})
  }

  setCountry = ({target: { value: countryId }}) => {
    this.setState({countryId})
  }

  get token(){
    return qs.parse(window.location.search.substr(1)).token
  }

  get name(){
    return qs.parse(window.location.search.substr(1)).name || ''
  }

  get countryId(){
    return qs.parse(window.location.search.substr(1)).countryId
  }

  getError = (fieldName) =>{
    if(this.props.error && this.props.error.meta && this.props.error.meta[fieldName]) {
      return this.props.error.meta[fieldName].join(', ')
    } else {
      return null
    }
  }

  submit = async () => {
    try{
      await this.actions.acceptInvitation({...this.state, token: this.token})
      await this.actions.verify()
      this.props.history.push('/')
    }catch(error){
      this.actions.snackbar.error('Failed to confirm account!')
    }
  }

  render = () =>
    <CenteredCard className={styles.card}>
      <CardContent onKeyUp={(e) => eventKeyMatches(e, KEYS.enter) && this.submit()}>
        <Typography variant='h6'>Create your account</Typography>
        <Typography variant='body2'>To continue</Typography>
        <TextField
          autoFocus={window.innerWidth > 500}
          label='Name'
          onChange={this.setName}
          fullWidth
          margin="normal"
          value={this.state.name}
          error={!!this.getError('name')}
          helperText={this.getError('name')}
        />
        <CountrySelect
          countries={this.props.countries}
          label='Country'
          value={this.state.countryId}
          onChange={this.setCountry}
          error={!!this.getError('countryId')}
          helperText={this.getError('countryId')}
          fullWidth
          margin="normal"
        />
        <TextField
          label='Enter your new password'
          type='password'
          onChange={this.setPassword}
          ref={this.focusPasswordInput}
          fullWidth
          margin="normal"
          error={!!this.getError('password')}
          helperText={this.getError('password')}
        />
        <TextField
          label='Enter your password again'
          type='password'
          onChange={this.setPasswordConfirmation}
          fullWidth
          margin="normal"
          error={!!this.getError('passwordConfirmation')}
          helperText={this.getError('passwordConfirmation')}
        />
      </CardContent>
      <CardActions className={styles.actions}>
        <Button className={styles.button} variant='contained' color="primary" onClick={this.submit}>Submit</Button>
      </CardActions>
    </CenteredCard>
}

const styles = StyleSheet({
  error: {
    color: 'red'
  },
  button:{
    float: 'right',
    display: 'block',
    maxWidth: 75,
    margin: 0,
  },
  card: {
    padding: 15,
    paddingBottom: 20
  },
  actions: {
    flexWrap: 'wrap',
    alignItems: 'flex-end',
    flexDirection: 'column',
    paddingLeft: 16,
    paddingRight: 16,
  }
})

export default connect(({tokens, countries}) => ({...countries, ...tokens}))(AcceptInvitation)